/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from "relay-runtime";

import { FragmentRefs } from "relay-runtime";
export type ExpenseRow_phaseBaselineExpense = {
    readonly id: string;
    readonly phaseId: number | null;
    readonly expenseCategory: {
        readonly id: string;
        readonly name: string | null;
    } | null;
    readonly expenseCost: number | null;
    readonly expenseMarkup: number | null;
    readonly expenseRevenue: number | null;
    readonly expenseProfit: number | null;
    readonly " $refType": "ExpenseRow_phaseBaselineExpense";
};
export type ExpenseRow_phaseBaselineExpense$data = ExpenseRow_phaseBaselineExpense;
export type ExpenseRow_phaseBaselineExpense$key = {
    readonly " $data"?: ExpenseRow_phaseBaselineExpense$data | undefined;
    readonly " $fragmentRefs": FragmentRefs<"ExpenseRow_phaseBaselineExpense">;
};



const node: ReaderFragment = (function(){
var v0 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
};
return {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "ExpenseRow_phaseBaselineExpense",
  "selections": [
    (v0/*: any*/),
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "phaseId",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "ExpenseCategory",
      "kind": "LinkedField",
      "name": "expenseCategory",
      "plural": false,
      "selections": [
        (v0/*: any*/),
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "name",
          "storageKey": null
        }
      ],
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "expenseCost",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "expenseMarkup",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "expenseRevenue",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "expenseProfit",
      "storageKey": null
    }
  ],
  "type": "PhaseBaselineExpenseType"
};
})();
(node as any).hash = '57e9921612ffb7d4945942e5876c037c';
export default node;
